import type { GeneratedLesson } from "../types";
import { Lightbulb } from "lucide-react";

interface ActivitiesSectionProps {
  lesson: GeneratedLesson;
}

export function ActivitiesSection({ lesson }: ActivitiesSectionProps) {
  if (!lesson.activities || lesson.activities.length === 0) {
    return null;
  }

  return (
    <div className="mb-6">
      <div className="flex items-center gap-2 mb-4">
        <Lightbulb
          className="w-5 h-5"
          style={{ color: "var(--primary-color)" }}
        />
        <h3
          className="text-xl font-bold"
          style={{ color: "var(--text-primary)" }}
        >
          Atividades Propostas
        </h3>
      </div>

      <div className="space-y-4">
        {lesson.activities.map((activity, idx) => (
          <div
            key={idx}
            className="p-4 border rounded-lg"
            style={{ borderColor: "var(--border-color)" }}
          >
            <h4
              className="font-bold mb-2"
              style={{ color: "var(--text-primary)" }}
            >
              {activity.title}
            </h4>
            <p className="mb-2" style={{ color: "var(--text-secondary)" }}>
              {activity.description}
            </p>
            {activity.duration && (
              <p className="text-sm" style={{ color: "var(--text-tertiary)" }}>
                ⏱ {activity.duration}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
